import { FC, PropsWithChildren, useEffect } from "react";
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from "@apoloenergia/metronic/assets/ts/components";
import { useRouter } from "next/router";
import { useMenusContext } from "@/context";

let initialized: boolean = false;

function bootstrap() {
  import("@apoloenergia/metronic/assets/js/polyfills");
  MenuComponent.bootstrap();
  DrawerComponent.bootstrap();
  ToggleComponent.bootstrap();
  ScrollComponent.bootstrap();
}

function reinitialization() {
  MenuComponent.reinitialization();
  DrawerComponent.reinitialization();
  ToggleComponent.reinitialization();
  ScrollComponent.reinitialization();
}

export const Metronic: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useRouter();

  const menus = useMenusContext();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const listener = () => {
      if (initialized) {
        reinitialization();
      } else {
        bootstrap();
      }
      initialized = true;
    };

    listener();

    window.addEventListener("resize", listener);

    return () => {
      window.removeEventListener("resize", listener);
    };
  }, [pathname, menus]);

  return <>{children}</>;
};
